import React, { Component } from 'react';
import { Column, Row, Grid } from 'packages/components';
import { Player } from '../../VcardTeam/player';
import './_styles.scss';
import Device from 'src/devices/device';
import Translator from '../../../../requests/apa/Translator';

interface IPlayerProps {}

export class Players extends Component<IPlayerProps> {
    state: any;
    keys: any;
    constructor(props: IPlayerProps) {
        super(props);
        this.state = {
            playerDataHome: {
                idTeam: '',
                title: '',
            },
            playerDataAway: {
                idTeam: '',
                title: '',
            },
           matchId: '' 
        };
        this.keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;

        this.getDataRibbons = this.getDataRibbons.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    getDataRibbons() {
        const dataStorage = localStorage.getItem('match');
        const dataMatch = dataStorage ? JSON.parse(dataStorage) : {};
        const { homeTeam, awayTeam } = dataMatch;
        const teamIdHome = homeTeam ? homeTeam.id : '';
        const teamIdAway = awayTeam ? awayTeam.id : '';
        const titleHome = homeTeam ? `${Translator.get('match_detail_players_label')} ${homeTeam.name}` : '';
        const titleAway = awayTeam ? `${Translator.get('match_detail_players_label')} ${awayTeam.name}` : '';

        const playerDataHome = {
          typeTeam: 'home',
            idTeam: teamIdHome,
            title: titleHome,
        };

        const playerDataAway = {
            typeTeam: 'away',
            idTeam: teamIdAway,
            title: titleAway,
        };
        this.setState({ playerDataHome, playerDataAway, matchId: dataMatch.id });
    }

    onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        const up = currentKey === 'UP';
        const element = document.getElementById('scroll');
        if (element) element.scrollTop = 500;

    }

    componentDidMount() {
        this.getDataRibbons();
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
    }

    componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    render() {
        const { playerDataHome, playerDataAway, matchId } = this.state;
        return (
            <Grid className='vcardMatch_ribbons-player-container'>
                <Row>
                    <Column lg={12} className="vcardMatch_ribbons-players">
                        <Row className="vcardMatch_ribbon-player-wrapper">
                            <Player playerDataMatch={{playerDataHome: playerDataHome, playerDataAway: playerDataAway, matchId: matchId}} key={Math.random() * 10} {...this.props}/>
                        </Row>
                    </Column>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Players/index.tsx